import React from 'react';
import EventCard from './EventCard';
import './EventsGrid.css';

const EventsGrid = ({ events }) => {
  return (
    <div className="events-grid">
      {events.map((event, index) => (
        <div key={event.id} className={`fade-up stagger-${index + 1}`}>
          <EventCard event={event} />
        </div>
      ))}
    </div>
  );
};

export default EventsGrid;
